import React, { Component } from 'react';
import './Comments.css';
import moment from 'moment';
import Avatar from 'react-avatar';

class Comments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      comments: this.props.comments,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.comments !== undefined) {
      if (
        JSON.stringify(nextProps.comments) !==
        JSON.stringify(this.props.comments)
      )
        this.setState({
          comments: nextProps.comments,
        });
    }
  }

  messageChangeHandler = (event) => {
    this.setState({ message: event.target.value });
  };

  onSubmit = (event, onComment) => {
    event.preventDefault();
    onComment(this.state.message);
    this.setState({ message: '' });
  };

  formatDate = (date) => {
    moment.locale('es');
    return moment(date).format('LLLL');
  };

  render() {
    const { textareaLabel, submitLabel, onComment } = this.props;
    const { comments } = this.state;

    return (
      <div>
        <ul className="sl-comments-list">
          {comments.map((comment, index) => (
            <li key={index}>
              <div className="sl-comments-avatar">
                <Avatar
                  name={comment.userName || 'Maria Luis'}
                  size="60"
                  round={true}
                />
              </div>
              <div className="sl-comments-info">
                <h4 className="title">{comment.userName}</h4>
                <div className="date">
                  {this.formatDate(comment.datetime)}, {comment.userName || ' '}
                </div>
                <div className="message">{comment.body}</div>
              </div>
            </li>
          ))}
        </ul>

        <form onSubmit={(event) => this.onSubmit(event, onComment)}>
          <div className="form-group">
            <label htmlFor="commentsInput">
              {textareaLabel ? textareaLabel : 'Mensaje'}
            </label>
            <textarea
              id="commentsInput"
              className="form-control"
              rows="3"
              value={this.state.message}
              onChange={this.messageChangeHandler}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">
            {submitLabel ? submitLabel : 'Enviar'}
          </button>
        </form>
      </div>
    );
  }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/components/Comments/Comments.jsx